import onbClient from '../../../registration/util/client';
import { dispatch } from 'nike-re-framejs';
import { handleServerErrors } from '../../../registration/util/error';
import { nuiCtx } from '../../../../common/initialization';

export function getForcedActionStatus() {
    onbClient
        .get(`/post/forced-action-status`)
        .then(status => dispatch(setForcedActionStatus(status)))
        .catch(handleServerErrors());
    return db => db;
}

const setForcedActionStatus = status => db =>
    db.setIn(['account', nuiCtx.platform === 'portal' ? 'user' : 'userData', 'forcedActionStatus'], status);
